<ng-template #thisModalForm role="document" let-modal>

  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="thisFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="thisFormSubmitAttempt()" [formGroup]="thisForm" class="tablelist-form" autocomplete="off" name="no-autofill-form">
    <div class="modal-body">

      @if (showProgressInformation) {
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                <span [innerHtml]="progressInformation"></span>
              </div>
            </div>
          </div>
        </div>
      }
      
      @if (input0Show) {
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="input0-field" class="form-label">{{fieldCaption}}</label>
              @if(this.input0Values != undefined) {
                <select
                  autocomplete="off" name="no-autofill-select"
                  class="form-select mr-5"
                  formControlName="input0"
                  id="input0-field"
                  [ngClass]="{
                    'is-invalid': thisFormSubmitted && formOfThis['input0'].errors
                  }"
                >
                  <option></option>
                  @for (object of this.input0Values; track object.name) {
                    <option [ngValue]="object.id">{{object.name}}</option>
                  }
                </select>
                @if (thisFormSubmitted && formOfThis['input0'].hasError('forbiddenValue')) {
                  <div class="invalid-feedback" style="display:block;">{{input0ForbiddenIdMessage ?? 'Please select a different value'}}</div>
                } @else {
                  <div class="invalid-feedback">A value is required</div>
                }
              } @else {
                <input
                  autocomplete="off" name="no-autofill-input0" aria-autocomplete="none"
                  class="form-control"
                  data-lpignore="true"
                  formControlName="input0"
                  id="input0-field"
                  [ngClass]="{
                    'is-invalid': thisFormSubmitted && formOfThis['input0'].errors,
                    'text-end': input0EnforceIntegerInput
                  }"
                  placeholder=""
                  [type]="input0EnforceIntegerInput ? 'number' : 'text'"
                  [attr.step]="input0EnforceIntegerInput ? 1 : null"
                  [attr.pattern]="input0EnforceIntegerInput ? '^[0-9]*$' : null"
                  [attr.inputmode]="input0EnforceIntegerInput ? 'numeric' : null"
                  [appOnlyInteger]="input0EnforceIntegerInput"
                  [readonly]="preventAutofill"
                  (mousedown)="preventAutofill=false; ($any($event.target)).readOnly=false; ($any($event.target)).focus()"
                />

                @if(formOfThis['input0'].hasError('maxlength')) {
                  <div class="invalid-feedback">Maximum length of {{input0MaxLength}} characters has been exceeded</div>
                } @else if (formOfThis['input0'].hasError('invalidEmail')) {
                  <div class="invalid-feedback">Please enter a valid email address</div>
                } @else if (formOfThis['input0'].hasError('greaterThanZero')) {
                  <div class="invalid-feedback">Please enter a value greater than 0</div>
                } @else {
                  <div class="invalid-feedback">A value is required</div>
                }
              }
            </div>
          </div>
        </div>
      }

      @if (date0Show) {
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="date0-field" class="form-label">{{date0Caption}}</label>
              <input
                autocomplete="off" name="no-autofill-date0"
                class="form-control"
                data-lpignore="true"
                formControlName="date0"
                id="date0-field"
                type="date"
                [attr.max]="date0EnforceNotFuture ? maxDateAsIsoDate : null"
                [ngClass]="{
                  'is-invalid': thisFormSubmitted && formOfThis['date0'].errors
                }"
              />

              @if(formOfThis['date0'].hasError('dateInPast')) {
                <div class="invalid-feedback">Date cannot be in the past</div>
              } @else if(formOfThis['date0'].hasError('dateInFuture')) {
                <div class="invalid-feedback">Date cannot be in the future</div>
              } @else if(formOfThis['date0'].hasError('invalidDate')) {
                <div class="invalid-feedback">Please enter a valid date</div>
              } @else {
                <div class="invalid-feedback">A date is required</div>
              }
            </div>
          </div>
        </div>
      }

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="thisFormCancel()">Close</button>
        <button type="submit" [disabled]="!submitButtonEnabled" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-completed-modal-form #completedModalForm
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
